import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const Network = () => {
  const { t, i18n } = useTranslation();
  return (
    <Box sx={{ textAlign: "center", pt: 10, width: 1, pb: 20 }}>
      <Typography variant="h4">{t("design")}</Typography>
      <Typography
        sx={{
          width: 1 / 2,
          marginLeft: "auto",
          marginRight: "auto",
          pt: 1,
          lineHeight: "2.2em",
        }}
        dangerouslySetInnerHTML={{ __html: t("design2") }}
      ></Typography>
      {/* <Box sx={{ width: 1, display: "flex", justifyContent: "center", pt: 6 }}>
        <Box sx={{ display: { md: "inline-block", sm: "none", xs: "none" } }}>
          <Box
            sx={{
              backgroundImage: `url("img/gragh1_non.png")`,
              backgroundSize: { md: "850px 450px" },
              backgroundRepeat: "none",
              width: { md: "850px" },
              height: "450px",
            }}
          >
            <Box
              sx={{
                pl: 84,
                paddingTop: "60px",
                color: "white",
                width: "200px",
              }}
            >
              &nbsp;{t("ourcustomers")}
            </Box>
            <Box
              sx={{
                display: "flex",
                ml: 2,
                mt: 8,
                width: "580px",
                justifyContent: "space-around",
              }}
            >
              <Box
                sx={{
                  p: 1,
                  border: "1px solid lightgray",
                  borderRadius: "10px",
                  backgroundColor: "white",
                }}
              >
                R&D
              </Box>
              <Box
                sx={{
                  p: 1,
                  border: "1px solid lightgray",
                  borderRadius: "10px",
                  backgroundColor: "white",
                }}
              >
                {t("Platform")}
              </Box>
              <Box
                sx={{
                  p: 1,
                  border: "1px solid lightgray",
                  borderRadius: "10px",
                  backgroundColor: "white",
                }}
              >
                {t("Marketing")}
              </Box>
              <Box
                sx={{
                  p: 1,
                  border: "1px solid lightgray",
                  borderRadius: "10px",
                  backgroundColor: "white",
                }}
              >
                {t("Strategy")}
              </Box>
              <Box
                sx={{
                  p: 1,
                  border: "1px solid lightgray",
                  borderRadius: "10px",
                  backgroundColor: "white",
                }}
              >
                {t("Logistics")}
              </Box>
            </Box>
            <Box
              sx={{
                color: "white",
                paddingTop: "10px",
                position: "relative",
                left: "-130px",
                top: "+3px",
              }}
            >
              Product Fulfillment Service
            </Box>
            <Box
              sx={{
                pt: 17,
                position: "relative",
                left: "-360px",
                top: "+21px",
              }}
            >
              {t("Partners")}
            </Box>
            <Box
              sx={{
                position: "relative",
                left: "-121px",
                top: "-9px",
                // top: "-15px",
                lineHeight: "1.4em",
              }}
            >
              <Typography
                sx={{ fontSize: "15px" }}
                dangerouslySetInnerHTML={{ __html: t("Manufacturing") }}
              />
            </Box>
            <Box
              sx={{
                position: "relative",
                left: "+115px",
                // top: "-60px",
                top: "-55px",
                lineHeight: "1.4em",
              }}
            >
              <Typography
                sx={{ fontSize: "15px" }}
                dangerouslySetInnerHTML={{ __html: t("Outsourcing") }}
              />
            </Box>
          </Box>
        </Box> */}
      <Box
        sx={{
          pt: 2,
          // display: { md: "none", sm: "inline-block", xs: "inline-block" },
        }}
      >
        {i18n.language === "en" ? (
          <img src="/img/fullfill.jpeg" style={{ width: "70%" }} />
        ) : (
          <img src="/img/fulfill_ko.jpeg" style={{ width: "70%" }} />
        )}
      </Box>
    </Box>
    // </Box>
  );
};

export default Network;
